import { createRef } from 'react';
import tw from 'twin.macro';

import { Modal } from '@components/Modal';
import noInsightsImage from '@assets/images/no-insight-application.png';
import { CheckMarkIcon } from '@icons/CheckMarkIcon';
import { Button } from '@components/Button';
import { OpenInNewWindowIcon } from '@icons/OpenInNewWindowIcon';
import useOnClickOutside from '@app/hooks/useOnClickOutside';
import { CloseIcon } from '@icons/CloseIcon';

const Container = tw.div`relative flex flex-col w-[594px] items-center rounded-lg border border-accent-muted shadow-modal bg-neutral-background overflow-hidden`;
const ContentWrapper = tw.div`flex flex-col p-[16px] pb-[24px] w-full gap-[24px]`;
const Title = tw.div`flex justify-start w-full text-accent-1 text-xs font-bold uppercase`;
const Subtitle = tw.div`flex justify-start text-text-and-icon font-semibold text-xl`;
const Description = tw.div`flex justify-start text-text-and-icon-muted text-base font-normal`;
const InfoItem = tw.div`flex gap-[8px] items-center text-text-and-icon-muted text-sm font-normal`;
const CloseButton = tw.div`absolute top-[10px] right-[12px] flex items-center justify-center w-[30px] h-[30px] cursor-pointer bg-[rgba(0, 0, 0, 0.14)] rounded-[5px]`;

export const NoInsightsAppModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const containerRef = createRef<HTMLDivElement>();
  useOnClickOutside(containerRef, () => onClose());

  const handleContactSales = () => {
    window.open('mailto:sales@sounder.fm', '_blank');
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Modal onClose={onClose}>
      <Container ref={containerRef}>
        <CloseButton onClick={onClose}>
          <CloseIcon tw='fill-text-and-icon-invert' />
        </CloseButton>
        <img src={noInsightsImage} alt='No Insights App' tw='mt-[-1px]' />
        <ContentWrapper>
          <div tw='flex flex-col gap-[8px]'>
            <Title>Audio Insights</Title>
            <Subtitle>Find right advertising match</Subtitle>
            <Description>
              Audio Insights is a beta feature that helps you find the right advertising match for
              your music.
            </Description>
          </div>

          <div tw='flex justify-between gap-[24px]'>
            <div tw='flex flex-col gap-[8px]'>
              <InfoItem>
                <CheckMarkIcon tw='stroke-accent-1' />
                Brand Safety
              </InfoItem>
              <InfoItem>
                <CheckMarkIcon tw='stroke-accent-1' />
                Brand Suitability
              </InfoItem>
              <InfoItem>
                <CheckMarkIcon tw='stroke-accent-1' />
                Megaphone Integration
              </InfoItem>
              <InfoItem>
                <CheckMarkIcon tw='stroke-accent-1' />
                Omny Integration
              </InfoItem>
              <InfoItem>
                <CheckMarkIcon tw='stroke-accent-1' />
                Package inventory and tagging
              </InfoItem>
            </div>
            <div tw='flex flex-col justify-end'>
              <Button.Primary onClick={handleContactSales}>
                <OpenInNewWindowIcon tw='fill-text-and-icon-invert' />
                Contact Sales
              </Button.Primary>
            </div>
          </div>
        </ContentWrapper>
      </Container>
    </Modal>
  );
};
